import React from 'react';
export const AuthContext = React.createContext(null);
export const useAuth = () => {
    const ctx = React.useContext(AuthContext);
    if (ctx)
        return ctx;
    // fallback to a safe default so callers can destructure without throwing
    return {
        signInSilent: () => Promise.reject(new Error('Auth provider not initialized')),
        signInRedirect: () => { },
        signOut: () => { },
        signOutRedirectCallback: () => { },
        hasPermission: () => false,
        accessToken: undefined,
        isAuthenticated: false,
        isLoading: false,
        error: undefined,
        user: undefined,
        isSignIn: false
    };
};
